module.exports = __webpack_public_path__ + "static/media/ill_receptfornyelse.5a3ee9de.svg";